@let hasShiftBeenValidated =
  shiftCardTooltipStateService.hasShiftBeenValidated$ | async;
@let isLoadingValidations =
  (shiftCardTooltipStateService.isLoadingValidationsForUser$ | async) ||
  (shiftCardTooltipStateService.isShiftValidationLoading$ | async);
@let isLoadingValidationsError =
  shiftCardTooltipStateService.isLoadingValidationsError$ | async;
@let isShiftValid = shiftCardTooltipStateService.isShiftValid$ | async;
@if (shiftId) {
  @let isShiftDraggableFeatureFlag =
    'portal-shift-timeline-shift-drag-drop' | featureFlagPure | async;
  @let isShiftSelected =
    shiftMultiSelectHelperService.selectedShifts$
      | isShiftSelected: shiftId
      | async;
  @let shiftColorOption = shiftColorOption$ | async;
  @let hasProjectReadPermission =
    can(RoleAction.Read, RolePermissionSubject.Project);

  <div
    #shiftCardWrapper
    [draggable]="isShiftDraggableFeatureFlag && isShiftDraggable"
    (click)="
      isSelectionEnabled &&
        checkShiftKeyOnClick(
          $event,
          leftPixelPosition,
          rightPixelPosition,
          undoTemplate
        )
    "
  >
    <ng-container
      *ngTemplateOutlet="
        deferredAssignmentShiftCardHelperService.getPreviewTemplate();
        context: {
          isMinimalHeight: isMinimalHeight,
          showActivities: showActivities,
          leftPixelPosition: leftPixelPosition || 0,
          calculatedShiftWidth: calculatedShiftWidth || 0,
          shiftColorOption: shiftColorOption || null,
          label: label,
          project: project,
          shiftCategoryId: shift.shiftCategoryId,
          hasProjectReadPermission: hasProjectReadPermission,
          showShiftValidation: showShiftValidation,
          hasShiftBeenValidated: !!hasShiftBeenValidated,
          isLoadingValidations: !!isLoadingValidations,
          isLoadingValidationsError: !!isLoadingValidationsError,
          isShiftValid: isShiftValid,
          isShiftCompleted: isShiftCompleted,
          isShiftStarted: isShiftStarted,
          shiftStartDetail: shiftStartDetail,
          shiftEndDetail: shiftEndDetail,
          isHighlighted: isHighlighted,
          numberOfInnerRows: numberOfInnerRows,
          innerRowIndex: innerRowIndex,
          shiftHeight: shiftHeight,
          isShiftDraggable: isShiftDraggable,
          isFiltered: isFiltered,
          isDragging: isDragging,
          isShiftVisible: !!isShiftVisible,
          contentTemplate: cardDetailWithTooltip,
          shift: shift,
          isShiftSelected: !!isShiftSelected,
          loadIconsImmediately: loadIconsImmediately,
          activityDisplayTemplate: activitiesContentTemplate,
          areActivitiesOverlapping: rowsActivities.length > 1,
        }
      "
    ></ng-container>
  </div>

  <ng-template #cardDetailWithTooltip>
    <wilson-shift-validation-tooltip-wrapper
      [style.height.px]="shiftHeight - 2"
      [style.display]="'block'"
      [attr.data-test-id]="
        'wilson-assignment-shift-card:shift-validation-tooltip-wrapper' +
        shiftName
      "
      [showShiftValidation]="showShiftValidation"
      [plannedShiftStartDateTime]="plannedShiftStartDateTime"
      [plannedShiftEndDateTime]="plannedShiftEndDateTime"
      [accurateShiftStartDateTime]="shiftStartDetail.date"
      [accurateShiftEndDateTime]="shiftEndDetail.date"
      [shiftStartTimeDifference]="shiftStartDetail.timeDifference"
      [shiftEndTimeDifference]="shiftEndDetail.timeDifference"
      [shiftStartTimeType]="shiftStartDetail.type"
      [shiftEndTimeType]="shiftEndDetail.type"
      [plannedStartLocation]="plannedStartLocation"
      [plannedEndLocation]="plannedEndLocation"
      [reportedStartLocation]="reportedStartLocation"
      [reportedEndLocation]="reportedEndLocation"
      [displayTooltip]="!!isTooltipVisible"
    >
      <ng-container
        *ngTemplateOutlet="lightWeightAssignmentShiftCard"
      ></ng-container>
    </wilson-shift-validation-tooltip-wrapper>
  </ng-template>

  <ng-template #lightWeightAssignmentShiftCard>
    <ng-container
      *ngTemplateOutlet="
        deferredAssignmentShiftCardHelperService.getPreviewTemplateContent();
        context: {
          shift: shift,
          showShiftValidation: showShiftValidation,
          isLoadingValidations: !!isLoadingValidations,
          hasShiftBeenValidated: !!hasShiftBeenValidated,
          isShiftValid: isShiftValid,
          isLoadingValidationsError: !!isLoadingValidationsError,
          isShiftCompleted: isShiftCompleted,
          isShiftStarted: isShiftStarted,
          shiftStartDetail: shiftStartDetail,
          shiftEndDetail: shiftEndDetail,
          isMinimalHeight: isMinimalHeight,
          showActivities: showActivities,
          loadIconsImmediately: loadIconsImmediately,
          numberOfInnerRows: numberOfInnerRows,
          innerRowIndex: innerRowIndex,
          contentTemplate: activitiesContentTemplate,
          areActivitiesOverlapping: rowsActivities.length > 1,
        }
      "
    ></ng-container>
  </ng-template>

  <ng-template #activitiesContentTemplate>
    <ng-container
      *ngTemplateOutlet="
        deferredAssignmentShiftCardHelperService.getActivitiesContentTemplate();
        context: {
          showActivities: showActivities,
          calculatedShiftWidth: calculatedShiftWidth
            ? calculatedShiftWidth - SHIFT_WIDTH_ADJUSTMENT_FOR_ACTIVITIES_PX
            : 0,
          isDragging: isDragging,
          rowsActivities: rowsActivities,
          shiftStartDetail: shiftStartDetail,
          shiftEndDetail: shiftEndDetail,
          publicationStatus: publicationStatus,
          isActivityDraggable: isActivityDraggable,
          frameLength: frameLength || 0,
          timeframe: timeframe,
          userId: shift.userId || '',
          isMoveMode: !!isMoveMode,
          isMinimalHeight: isMinimalHeight,
          selectActivityCallback: selectActivityCallback.bind(this),
          startActivityDragCallback: startActivityDragCallback.bind(this),
          draggingCallback: draggingCallback.bind(this),
          endActivityDragCallback: endActivityDragCallback.bind(this),
          setSnappingForResizeCallback: setSnappingForResizeCallback.bind(this),
          fillActivityGapLeftCallback: fillActivityGapLeftCallback.bind(this),
          handleResizeLeftCallback: handleResizeLeftCallback.bind(this),
          fillActivityGapRightCallback: fillActivityGapRightCallback.bind(this),
          handleResizeRightCallback: handleResizeRightCallback.bind(this),
        }
      "
    ></ng-container>
  </ng-template>
}

<ng-template #undoTemplate>
  <wilson-nz-message-timer-line [duration]="MESSAGE_DURATION">
    <wilson-message-with-undo-option></wilson-message-with-undo-option>
  </wilson-nz-message-timer-line>
</ng-template>
